<div class="admins-page">
  <div class="admins-header">
    <div class="admins-heading">
      <h2 class="admins-title">Platform Admins</h2>
      <p class="admins-sub">
        People authorized to use this console. Removing an admin revokes access
        immediately.
      </p>
    </div>
    <lib-cdw-button
      *ngIf="currentAdminIsSuper$ | async"
      level="primary"
      type="button"
      [disabled]="(mutating$ | async) ?? false"
      (buttonClick)="openAddDialog()"
    >
      <lib-cdw-icon icon="add" size="18px"></lib-cdw-icon>
      Add admin
    </lib-cdw-button>
  </div>

  <div class="form-error" *ngIf="error$ | async as error">
    <lib-cdw-icon icon="error" size="20px"></lib-cdw-icon>
    <span>{{ error }}</span>
  </div>

  <!-- Loading -->
  <div class="admins-state" *ngIf="loading$ | async; else loaded">
    <mat-spinner diameter="36"></mat-spinner>
    <span class="admins-state-text">Loading admins…</span>
  </div>

  <ng-template #loaded>
    <ng-container *ngIf="admins$ | async as admins">
      <!-- Empty -->
      <div class="admins-state" *ngIf="admins.length === 0; else table">
        <lib-cdw-icon icon="group" size="40px"></lib-cdw-icon>
        <span class="admins-state-text">No platform admins yet.</span>
      </div>

      <ng-template #table>
        <div
          class="admins-table-card"
          *ngIf="{
            sort: (sortState$ | async),
            currentId: (currentAdminId$ | async),
            isSuper: (currentAdminIsSuper$ | async)
          } as ctx"
        >
          <!-- Header table: fixed (does not scroll); the gutter is reserved so
               its columns line up with the scrolling body below. -->
          <div class="admins-table-headwrap">
            <table class="admins-table">
              <colgroup>
                <col class="col-name" />
                <col class="col-email" />
                <col class="col-role" />
                <col class="col-added" />
                <col class="col-actions" />
              </colgroup>
              <thead>
                <tr>
                  <th class="sortable" scope="col" (click)="toggleSort('name')">
                    Name
                    <lib-cdw-icon
                      *ngIf="ctx.sort?.key === 'name'"
                      [icon]="ctx.sort?.dir === 'asc' ? 'arrow_upward' : 'arrow_downward'"
                      size="16px"
                    ></lib-cdw-icon>
                  </th>
                  <th class="sortable" scope="col" (click)="toggleSort('email')">
                    Email
                    <lib-cdw-icon
                      *ngIf="ctx.sort?.key === 'email'"
                      [icon]="ctx.sort?.dir === 'asc' ? 'arrow_upward' : 'arrow_downward'"
                      size="16px"
                    ></lib-cdw-icon>
                  </th>
                  <th scope="col">Role</th>
                  <th class="sortable" scope="col" (click)="toggleSort('addedAt')">
                    Added
                    <lib-cdw-icon
                      *ngIf="ctx.sort?.key === 'addedAt'"
                      [icon]="ctx.sort?.dir === 'asc' ? 'arrow_upward' : 'arrow_downward'"
                      size="16px"
                    ></lib-cdw-icon>
                  </th>
                  <th scope="col" class="actions-col" aria-label="Actions"></th>
                </tr>
              </thead>
            </table>
          </div>

          <!-- Body table: scrolls; the scrollbar spans only this region. -->
          <div class="admins-table-scroll">
            <table class="admins-table">
              <colgroup>
                <col class="col-name" />
                <col class="col-email" />
                <col class="col-role" />
                <col class="col-added" />
                <col class="col-actions" />
              </colgroup>
              <tbody>
                <tr *ngFor="let admin of admins; trackBy: trackById">
                  <td>{{ admin.name }}</td>
                  <td class="email-cell">{{ admin.email }}</td>
                  <td>
                    <span *ngIf="admin.isSuper" class="super-badge">Super</span>
                    <span *ngIf="!admin.isSuper">—</span>
                  </td>
                  <td>{{ admin.addedAt ? (admin.addedAt | date: 'mediumDate') : '—' }}</td>
                  <td class="actions-col">
                    <button
                      *ngIf="ctx.isSuper && admin.id !== ctx.currentId"
                      type="button"
                      class="remove-btn"
                      [disabled]="(mutating$ | async) ?? false"
                      (click)="confirmRemove(admin)"
                      [attr.aria-label]="'Remove ' + admin.name"
                    >
                      <lib-cdw-icon icon="delete" size="18px"></lib-cdw-icon>
                    </button>
                    <span *ngIf="admin.id === ctx.currentId" class="you-badge">You</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </ng-template>
    </ng-container>
  </ng-template>
</div>
